"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
    value,
    onChange,
    debounceTime = 200,
    ...rest
  } = props;
  const [draft, setDraft] = (0, _react.useState)(value ?? '');
  (0, _react.useEffect)(() => {
    if (draft !== value) setDraft(value);
  }, [value]);
  const timeout = (0, _react.useRef)();
  (0, _hooks.useUpdateEffect)(() => {
    if (timeout.current) clearTimeout(timeout.current);
    timeout.current = setTimeout(() => onChange(draft), debounceTime);
  }, [draft]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
    ref: ref,
    value: draft,
    onChange: ({
      target
    }) => setDraft(target.value),
    ...rest
  });
});